import { Link } from "react-router-dom";
import { Home, Wrench, Camera, FileText } from "lucide-react";
import SEOHead from "@/components/SEOHead";
import { CTA_DEVIS } from "@/data/forms";

const links = [
  { to: "/", label: "Accueil", icon: Home },
  { to: "/services", label: "Services", icon: Wrench },
  { to: "/realisations", label: "Réalisations", icon: Camera },
  { to: "/demande-devis", label: CTA_DEVIS, icon: FileText },
];

export default function NotFound() {
  return (
    <div data-testid="not-found-page" style={{ backgroundColor: '#fff', minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '64px 24px' }}>
      <SEOHead title="Page introuvable (404) | VGI Construct" description="Cette page n'existe pas. Retrouvez nos services, réalisations et demandez votre devis gratuit." path="/404" noindex />
      <div style={{ textAlign: 'center', maxWidth: '560px' }}>
        <p style={{ color: '#8B0000', fontWeight: 900, fontSize: 'clamp(4rem, 12vw, 7rem)', fontFamily: "'Cabinet Grotesk', sans-serif", lineHeight: 1, margin: '0 0 12px' }}>404</p>
        <h1 style={{ fontFamily: "'Cabinet Grotesk', sans-serif", fontSize: 'clamp(1.6rem, 4vw, 2.4rem)', fontWeight: 900, color: '#1a1a1a', marginBottom: '12px' }}>Cette page n'existe pas</h1>
        <p style={{ color: '#666', fontSize: '16px', lineHeight: 1.7, marginBottom: '32px' }}>L'adresse est peut-être erronée ou la page a été déplacée. Voici où aller :</p>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '12px' }}>
          {links.map(l => (
            <Link key={l.to} to={l.to} data-testid={`notfound-link-${l.to.replace("/", "") || "home"}`}
              style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 20px', borderRadius: '100px', textDecoration: 'none', fontWeight: 700, fontSize: '14px', backgroundColor: l.to === "/demande-devis" ? '#8B0000' : '#f5f5f5', color: l.to === "/demande-devis" ? '#fff' : '#1a1a1a' }}>
              <l.icon size={16} /> {l.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
